/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import StatusController from '../../components/statusController'
import MetaTags from 'react-meta-tags'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label
} from 'reactstrap'
import Swal from 'sweetalert2'

import { toast } from 'react-toastify'
import Excel from 'exceljs'
import { Loading } from '../../components/Loading'
import Select from 'react-select'

// import images
import Services from '../../services/sendMessage'
import {
  handlerUser,
  handlerFile,
  handleFileSelectedDropzone
} from '../../services/instanceFunctions'
import { useUserInfo } from 'context/userContext'

import './styles.css'

import 'chartist/dist/scss/chartist.scss'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import { Form, Button } from 'react-bootstrap'
import { listType } from '../../util/mocks'
import ServicesSegmentation from '../../services/segmentation'

import ptBR from 'date-fns/locale/pt-BR'
import { format } from 'date-fns'
import { EditorState } from 'draft-js'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { ModalQrcode } from 'components/modalQrcode'
import { ModalQrcodeZApi } from 'components/modalQrcodeZApi'
import { TextArea } from '../../components/TextArea'
import { InputComponent } from 'components/inputComponent'
import { useFileUpload } from 'hooks/useFileUpload'
import { FileUpload } from 'components/fileUpload'
import { PlanilhaUploadCard } from './PlanilhaUploadCard'
import { SectionCard } from './components/SectionCard'
import { CampaignStepper } from './components/CampaignStepper'
import { SpreadsheetInfoBanner } from './components/SpreadsheetInfoBanner'
import { ContactsEmptyState } from './components/ContactsEmptyState'
import { FormLabelWithTooltip } from './components/FormLabelWithTooltip'
import {
  ReviewPanel,
  formatScheduleLabel
} from './components/ReviewPanel'
registerLocale('pt-BR', ptBR)

const customStyles = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
}

const listMomento = [
  { label: 'Enviar Agora', value: 'now' },
  { label: 'Agendar Envio', value: 'after' }
]

const STEPS = ['Campanha', 'Contatos', 'Mensagem', 'Revisar']
const DRAFT_STORAGE_KEY = 'zap-plus-enviar-planilha-draft-v1'

const EnviarPlanilha = () => {
  const { userPlan } = useUserInfo()

  const { onDrop } = useFileUpload()

  const [imagem, setImagem] = useState(null)
  const [btn1, setBtn1] = useState(null)
  const [btn2, setBtn2] = useState(null)
  const [btn3, setBtn3] = useState(null)
  const [descricaoLink, setDescricaoLink] = useState(null)
  const [tituloLink, setTituloLink] = useState(null)
  const [linkUrl, setLinkUrl] = useState(null)
  const [linkAction, setLinkAction] = useState(null)
  const [campanha, setCampanha] = useState(null)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  const [nomeDoArquivo, setNomeDoArquivo] = useState('')
  const [file, setFile] = useState(null)
  const [messageVariables, setMessageVariables] = useState([])
  const [zapiData, setZapiData] = useState({
    id: null,
    token: null
  })
  const [momento, setMomento] = useState('now')
  const [horaEnvio, setHoraEnvio] = useState(null)
  const [horaEnvioDatePicker, setHoraEnvioDatePicker] = useState(null)

  const [message, setMessage] = useState('')

  const [type, setType] = useState('texto')
  const [user, setUser] = useState(null)
  const [statusInstancia, setStatusInstancia] = useState(0)
  const [zapMais, setZapMais] = useState(false)
  const [instanceName, setInstanceName] = useState(null)
  const [openModalQrcode, setOpenModalQrcode] = useState(false)
  const [instanceStateChecked, setInstanceStateChecked] = useState(false)
  const [rendered, setRendered] = useState(false)

  const [descricao, setDescricao] = useState('')
  const [block, setBlock] = useState(false)
  const [mensagemCampanhaExistente, setmensagemCampanhaExistente] =
    useState(false)

  const [campanhaExist, setCampanhaExist] = useState(false)
  const [campanhaList, setCampanhaList] = useState([])
  const [grupo, setGrupo] = useState([])
  const [segmentation, setSegmentation] = useState([])

  const [grupoList, setGrupoList] = useState([])
  const [segmentacoesList, setSegmentacoesList] = useState([])

  const [rows, setRows] = useState([])

  const [tableConfig, setTableConfig] = useState({
    options: {
      collapse: false,
      order: true,
      more: false,
      pagination: true,
      createInstancia: true
    },
    config: {
      resendPurchaseText: 'Reenviar Qr codes da compra'
    },
    filters: {
      searchTerm: null,
      statusTransaction: 'paid',
      paidSale: false,
      startSaleDate: null,
      endSaleDate: null,
      eventId: null,
      sellerId: null
    },
    total: 0,
    currentPage: 0,
    rowsPerPage: 15
  })

  const [listUser, setListUser] = useState([])
  const [tabela, setTabela] = useState([])

  const [loading, setLoading] = useState(false)
  const [checkSair, setCheckSair] = useState(false)

  const [activeStep, setActiveStep] = useState(0)
  const [planilhaFileError, setPlanilhaFileError] = useState('')

  const loadDadosTable = async () => {
    const init = tableConfig.currentPage * tableConfig.rowsPerPage
    const finish = init + tableConfig.rowsPerPage

    const filterDados = tabela.slice(init, finish)
    setRows(filterDados)
  }

  const loadInstance = async () => {
    const result = await Services.getInstance()
    if (result.status === 200) {
      const info = []
      result.data.data.items.map((item) => {
        info.push({
          label: item.name,
          value: item.id,
          tokenZapi: item.token_zapi,
          idZapi: item.id_zapi,
          useLocal: item.use_local
        })
      })
      setListUser(info)
    }
  }

  const handleClose = () => {
    setLoading(false)
  }

  const handleImgSelected = (acceptedFiles) => {
    const fileReader = new FileReader()
    setCampanha(acceptedFiles[0])
    fileReader.readAsDataURL(acceptedFiles[0])

    fileReader.onload = function (fileLoadedEvent) {
      const imageBase64 = fileLoadedEvent.target?.result

      setImagem(imageBase64)
    }
  }

  const handleVideoSelected = (acceptedFiles) => {
    setCampanha(acceptedFiles[0])
  }

  const handlerType = (e) => {
    setType(e.value)
  }

  const handlerMomento = (e) => {
    setMomento(e.value)

    if (e.value !== 'now') {
      setCampanhaExist(false)
    }
  }

  const handlerSegmentation = async (e) => {
    setSegmentation(e.value)
    const result = await ServicesSegmentation.getSegmentedClients(e.value);

    if (result.status === 200) {
      const formattedData = result?.data?.data?.map((client) => {
        return {
          name: client.name,
          fone: client.telefone
        };
      });

      setTabela(formattedData)
      setRows(formattedData)
      setTableConfig({
        ...tableConfig,
        total: formattedData.length
      })
    } else {
      toast.error(result.data.message)
    }
  }

  const handlerGrupo = async (e) => {
    setGrupo(e.value)
    const result = await Services.getEspecificGrupo({ id: e.value, user })

    if (result.status === 200) {
      setTabela(result.data.data.items)
      setRows(result.data.data.items)
      setTableConfig({
        ...tableConfig,
        total: result.data.data.items.length
      })
    } else {
      toast.error(result.data.message)
    }
  }

  function handleChangeTransferDate(date) {
    const formattedDate = format(date, 'yyyy-MM-dd HH:mm:ss')

    setHoraEnvio(formattedDate)
    setHoraEnvioDatePicker(date)
  }

  const getCampanhas = async () => {
    const result = await Services.getCampanhas({ user })

    if (result.status === 200) {
      const aux = []
      result?.data?.data.map((item, index) => {
        aux.push({
          ...item,
          value: item?.id,
          label: item?.name
        })
      })
      setCampanhaList(aux)
    }
  }

  const getGrupos = async () => {
    const result = await Services.getGrupos(user)
    if (result.status === 200) {
      const aux = []
      result?.data?.data.items.map((item, index) => {
        aux.push({
          ...item,
          value: item?.id,
          label: item?.name
        })
      })
      setGrupoList(aux)
    }
  }

  const getSegmentacoes = async () => {
    const result = await ServicesSegmentation.listSegmentations(user)
    if (result.status === 200) {
      const formattedData = result?.data?.data?.map((item) => {
        return {
          value: item?.id,
          label: item?.name
        }
      });
      setSegmentacoesList(formattedData)
    }
  }

  function onCloseModalQrcode() {
    setOpenModalQrcode(false)
    setUser(null)
    setInstanceName(null)
  }

  function onCloseOnSuccessModalQrcode() {
    setOpenModalQrcode(false)
    setStatusInstancia(1)
  }

  const handlerCampanhaExistente = async (dados) => {
    Swal.fire({
      icon: 'warning',
      title: 'Atenção..',
      text: `Você selecionou uma campanha já existente, as configurações da campanha serão setadas automaticamente conforme sua configuração inicial.
      Porém é necessario fazer o upload das midias novamente`,
      confirmButtonText: 'Sair'
    }).then((result) => {
      console.log(result)
    })

    setType(dados?.type)
    setmensagemCampanhaExistente(dados?.body)
    setCampanhaExist(dados?.value)
    setBlock(true)
  }

  const handleClearInstanceId = () => {
    setUser(null)
  }

  const handleAddVariable = useCallback(
    (variable) => {
      const el = document.getElementById('message-text-area')
      const cursorPosition =
        el && typeof el.selectionStart === 'number'
          ? el.selectionStart
          : message.length
      const next =
        message.substring(0, cursorPosition) +
        variable +
        message.substring(cursorPosition)
      const capped =
        next.length > 4096 ? next.slice(0, 4096) : next
      setMessage(capped)
      requestAnimationFrame(() => {
        if (el && typeof el.focus === 'function') {
          el.focus()
          const pos = Math.min(
            cursorPosition + variable.length,
            4096
          )
          el.setSelectionRange(pos, pos)
        }
      })
    },
    [message]
  )

  const clearPlanilha = () => {
    setFile(null)
    setPlanilhaFileError('')
    setTabela([])
    setRows([])
    setMessageVariables([])
    setTableConfig((prev) => ({
      ...prev,
      total: 0,
      currentPage: 0
    }))
  }

  const downloadModeloPlanilha = async () => {
    const workbook = new Excel.Workbook()
    const worksheet = workbook.addWorksheet('Contatos')
    worksheet.getCell('A1').value = 'nome'
    worksheet.getCell('B1').value = 'telefone'
    worksheet.getCell('A2').value = 'Exemplo de contato'
    worksheet.getCell('B2').value = '11988887777'
    worksheet.getColumn(1).width = 28
    worksheet.getColumn(2).width = 18

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'modelo-disparo-zap-plus.xlsx'
    a.click()
    URL.revokeObjectURL(url)
  }

  useEffect(() => {
    if (!rendered) {
      setRendered(true)
    }
    if (rendered) {
      loadInstance()
    }
  }, [rendered])

  useEffect(() => {
    if (user) {
      getCampanhas()
      getGrupos()
      getSegmentacoes()
    }
  }, [user])

  useEffect(() => {
    if (!rendered) return
    loadDadosTable()
  }, [tableConfig.currentPage, rendered])

  const stepComplete = useCallback(
    (stepIndex) => {
      if (stepIndex === 0) {
        const schedOk =
          userPlan === 'BASIC' ||
          momento !== 'after' ||
          (horaEnvioDatePicker && horaEnvio)
        const needInstance = listUser.length > 0
        const instanceOk = !needInstance || Boolean(user)
        return Boolean(
          String(descricao || '').trim() &&
            type &&
            schedOk &&
            instanceOk
        )
      }
      if (stepIndex === 1) {
        return tabela.length > 0
      }
      if (stepIndex === 2) {
        return String(message || '').trim().length > 0
      }
      return true
    },
    [
      descricao,
      type,
      momento,
      horaEnvioDatePicker,
      horaEnvio,
      tabela.length,
      message,
      userPlan,
      listUser.length,
      user
    ]
  )

  const canNavigateToStep = useCallback(
    (targetIndex) => {
      for (let s = 0; s < targetIndex; s++) {
        if (!stepComplete(s)) return false
      }
      return true
    },
    [stepComplete]
  )

  const handlePlanilhaDrop = (acceptedFiles, fileRejections) => {
    setPlanilhaFileError('')
    if (fileRejections && fileRejections.length > 0) {
      setPlanilhaFileError('Envie apenas arquivos no formato .xlsx.')
      return
    }
    if (!acceptedFiles || acceptedFiles.length === 0) return
    onDrop(
      acceptedFiles,
      fileRejections,
      100000000,
      () =>
        handleFileSelectedDropzone(
          acceptedFiles,
          setFile,
          setLoading,
          setTabela,
          setTableConfig,
          setRows,
          tableConfig,
          'planilha',
          setGrupo,
          Swal,
          setMessageVariables
        )
    )
  }

  const saveDraft = () => {
    try {
      const payload = {
        descricao,
        message,
        momento,
        type,
        user,
        savedAt: new Date().toISOString()
      }
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(payload))
      toast.success('Rascunho salvo')
    } catch {
      toast.error('Não foi possível salvar o rascunho')
    }
  }

  useEffect(() => {
    try {
      const raw = localStorage.getItem(DRAFT_STORAGE_KEY)
      if (!raw) return
      const d = JSON.parse(raw)
      if (typeof d.descricao === 'string') setDescricao(d.descricao)
      if (typeof d.message === 'string') setMessage(d.message)
      if (d.momento) setMomento(d.momento)
      if (d.type) setType(d.type)
    } catch {
      /* ignore */
    }
  }, [])

  const canReview =
    String(descricao || '').trim().length > 0 &&
    tabela.length > 0 &&
    String(message || '').trim().length > 0

  const submitDisparo = () =>
    handlerFile({
      functionType: 'disparo',
      zapMais,
      tabela,
      Swal,
      block,
      user,
      descricao,
      campanhaExist,
      imagem,
      type,
      campanha,
      linkUrl,
      horaEnvio,
      momento,
      setLoading,
      editorState,
      btn1,
      btn2,
      btn3,
      Services,
      mensagemCampanhaExistente,
      nomeDoArquivo,
      descricaoLink,
      tituloLink,
      linkAction,
      checkSair,
      setImagem,
      setBtn1,
      setBtn2,
      setBtn3,
      setUser,
      setDescricaoLink,
      setTituloLink,
      setLinkUrl,
      setLinkAction,
      setCampanha,
      setNomeDoArquivo,
      setFile,
      setMomento,
      setHoraEnvio,
      setHoraEnvioDatePicker,
      setType,
      setDescricao,
      setCampanhaExist,
      setCampanhaList,
      setRows,
      setTabela,
      setCheckSair,
      setTableConfig,
      message,
      setMessage
    })

  const hasAttachmentFields =
    type === 'imagem' ||
    type === 'imagem-botoes' ||
    type === 'arquivo' ||
    type === 'video-arquivo' ||
    type === 'audio-arquivo' ||
    type === 'link' ||
    (!block && (type === 'botoes' || type === 'imagem-botoes')) ||
    (!block && type === 'arquivo')

  return (
    <React.Fragment>
      {loading && <Loading open={loading} handleClose={handleClose} />}
      {zapMais && (
        <ModalQrcode
          showModal={openModalQrcode}
          onClose={onCloseModalQrcode}
          instanceId={user}
          statusInstance={statusInstancia}
          instanceName={instanceName}
          onSuccess={onCloseOnSuccessModalQrcode}
          instanceChecked={instanceStateChecked}
        />
      )}
      {!zapMais && (
        <ModalQrcodeZApi
          showModal={openModalQrcode}
          onClose={onCloseModalQrcode}
          instanceId={user}
          statusInstance={statusInstancia}
          instanceName={instanceName}
          onSuccess={onCloseOnSuccessModalQrcode}
          instanceChecked={instanceStateChecked}
          zapiData={zapiData}
        />
      )}

      <div className="page-content">
        <MetaTags>
          <title>Envio de Mensagens | Zap+</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title mb-1">Envio de Mensagens | Zap+</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Bem vindo ao Disparador Zap+
                  </li>
                </ol>
              </Col>
              <Col
                md={4}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center'
                }}
              >
                {user && (
                  <>
                    <span
                      style={{
                        marginRight: 10,
                        fontWeight: 500,
                        fontSize: 20
                      }}
                    >
                      {statusInstancia === 1
                        ? 'Conectado'
                        : statusInstancia === 3
                        ? 'Bloqueado'
                        : 'Desconectado'}
                    </span>
                    <StatusController statusInstancia={statusInstancia} />
                  </>
                )}
              </Col>
            </Row>
          </div>
          <Row>
            <Card className="enviar-planilha-card border shadow-sm">
              <CardBody className="p-3 p-md-4">
                <CampaignStepper
                  steps={STEPS}
                  activeIndex={activeStep}
                  onStepClick={setActiveStep}
                  canNavigateToStep={canNavigateToStep}
                />

                <div className="enviar-planilha-cards-stack">
                  {activeStep === 0 && (
                    <>
                      <SectionCard
                        title="Configure sua campanha"
                        subtitle="Nome, WhatsApp remetente, tipo de mensagem e agendamento."
                      >
                        <Row className="g-3">
                          <Col md={6}>
                            <Form.Group>
                              <FormLabelWithTooltip
                                htmlFor="nome-campanha"
                                required
                                tooltip="Nome interno para identificar este disparo no painel."
                              >
                                Nome da campanha
                              </FormLabelWithTooltip>
                              <Form.Control
                                id="nome-campanha"
                                type="text"
                                value={descricao}
                                onChange={(e) => {
                                  setDescricao(e.target.value)
                                  setCampanhaExist(false)
                                  setBlock(false)
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <FormGroup className="mb-0">
                              <FormLabelWithTooltip
                                htmlFor="tipo-mensagem"
                                required
                                tooltip="Escolha o formato da mensagem (texto, imagem, arquivo, etc.)."
                              >
                                Tipo de mensagem
                              </FormLabelWithTooltip>
                              <Select
                                inputId="tipo-mensagem"
                                value={
                                  listType.find((a) => a.value === type)
                                    ? listType.find((a) => a.value === type)
                                    : null
                                }
                                styles={customStyles}
                                onChange={(value) => handlerType(value)}
                                options={listType}
                                isDisabled={block}
                                classNamePrefix="select2-selection"
                                placeholder="Selecione..."
                              />
                            </FormGroup>
                          </Col>
                          {userPlan !== 'BASIC' && (
                            <Col md={6}>
                              <FormGroup>
                                <FormLabelWithTooltip
                                  htmlFor="momento-envio"
                                  required
                                  tooltip="Envio imediato ou agendado para data e hora específicas."
                                >
                                  Agendamento
                                </FormLabelWithTooltip>
                                <Select
                                  inputId="momento-envio"
                                  value={
                                    listMomento.find((a) => a.value === momento)
                                      ? listMomento.find(
                                          (a) => a.value === momento
                                        )
                                      : null
                                  }
                                  onChange={(value) => handlerMomento(value)}
                                  options={listMomento}
                                  classNamePrefix="select2-selection"
                                  placeholder="Selecione..."
                                />
                              </FormGroup>
                            </Col>
                          )}
                          {momento === 'after' && userPlan !== 'BASIC' && (
                            <Col md={6}>
                              <Form.Group>
                                <FormLabelWithTooltip
                                  htmlFor="hora-envio"
                                  required
                                  tooltip="Data e hora em que o disparo deve iniciar."
                                >
                                  Data e hora do envio
                                </FormLabelWithTooltip>
                                <ReactDatePicker
                                  id="hora-envio"
                                  className="form-control"
                                  selected={horaEnvioDatePicker}
                                  onChange={(date) => {
                                    handleChangeTransferDate(date)
                                  }}
                                  timeIntervals={15}
                                  showTimeSelect
                                  dateFormat="dd/MM/yyyy HH:mm:ss"
                                  locale="pt-BR"
                                />
                              </Form.Group>
                            </Col>
                          )}
                          <Col md={6}>
                            <FormGroup>
                              <FormLabelWithTooltip
                                htmlFor="quem-envia"
                                required={listUser.length > 0}
                                tooltip="Selecione qual WhatsApp conectado será usado para enviar."
                              >
                                Quem está enviando a mensagem?
                              </FormLabelWithTooltip>
                              <Select
                                inputId="quem-envia"
                                value={
                                  listUser.find((a) => a.value === user)
                                    ? listUser.find((a) => a.value === user)
                                    : null
                                }
                                onChange={(value) =>
                                  handlerUser(
                                    value,
                                    setLoading,
                                    setUser,
                                    Services,
                                    Swal,
                                    setStatusInstancia,
                                    setZapMais,
                                    setInstanceName,
                                    setOpenModalQrcode,
                                    handleClearInstanceId,
                                    setInstanceStateChecked,
                                    setZapiData
                                  )
                                }
                                options={listUser}
                                classNamePrefix="select2-selection"
                                placeholder="Selecione..."
                              />
                            </FormGroup>
                          </Col>
                          {descricao.length === 0 && (
                            <Col md={6}>
                              <FormGroup>
                                <FormLabelWithTooltip
                                  htmlFor="campanha-existente"
                                  tooltip="Reaproveita configurações de uma campanha anterior. É necessário enviar mídias novamente."
                                >
                                  Vincular a campanha anterior
                                </FormLabelWithTooltip>
                                <Select
                                  inputId="campanha-existente"
                                  value={
                                    campanhaList.find(
                                      (a) => a.value === campanhaExist
                                    )
                                      ? campanhaList.find(
                                          (a) => a.value === campanhaExist
                                        )
                                      : null
                                  }
                                  onChange={(value) =>
                                    handlerCampanhaExistente(value)
                                  }
                                  options={campanhaList}
                                  classNamePrefix="select2-selection"
                                  placeholder="Selecione..."
                                />
                              </FormGroup>
                            </Col>
                          )}
                        </Row>
                      </SectionCard>

                      {hasAttachmentFields && (
                <>
                  <div className="enviar-planilha-subtle-label mt-4 mb-2">
                    Anexos
                  </div>
                  <Row className="g-3">
                {(type === 'imagem' || type === 'imagem-botoes') && (
                  <Col xl={5} md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Imagem</Label>
                      <div className="file-uploader">
                        <FileUpload
                          dropzoneError={false}
                          text="Clique aqui para selecionar ou arraste a <strong>IMAGEM</strong>"
                          onDrop={(acceptedFiles, fileRejections) =>
                            onDrop(
                              acceptedFiles,
                              fileRejections,
                              10000000,
                              () => handleImgSelected(acceptedFiles)
                            )
                          }
                          maxSize={10000000}
                          accept={['.png', '.JPEG', '.jpeg', '.jpg']}
                          suggestion={
                            campanha?.name
                              ? `Imagem selecionada: <strong>${campanha.name}</strong>`
                              : null
                          }
                        />
                      </div>
                      {/* <div className="file-uploader">
                        <Input
                          type="file"
                          isDisabled={block}
                          label="Upload"
                          onChange={handleImgSelected}
                          accept=".pdf, .png, .JPEG, .jpeg, .jpg, .svg, .webp"
                        />
                      </div> */}
                    </FormGroup>
                  </Col>
                )}
                {type === 'arquivo' && (
                  <Col xl={5} md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Arquivo</Label>
                      <div className="file-uploader">
                        <FileUpload
                          dropzoneError={false}
                          text="Clique aqui para selecionar ou arraste o <strong>ARQUIVO PDF</strong>"
                          onDrop={(acceptedFiles, fileRejections) =>
                            onDrop(
                              acceptedFiles,
                              fileRejections,
                              50000000,
                              () => handleImgSelected(acceptedFiles)
                            )
                          }
                          maxSize={50000000}
                          accept={['.pdf']}
                          suggestion={
                            campanha?.name
                              ? `Arquivo de no máximo 50M<br/>Arquivo selecionado: <strong>${campanha.name}</strong>`
                              : 'Arquivo de no máximo 50M'
                          }
                        />
                      </div>
                    </FormGroup>
                  </Col>
                )}
                {type === 'video-arquivo' && (
                  <Col xl={5} md={5}>
                    <FormGroup>
                      <Label for="exampleEmail">Vídeo</Label>
                      <div className="file-uploader">
                        <FileUpload
                          dropzoneError={false}
                          text="Clique aqui para selecionar ou arraste o <strong>VÍDEO</strong>"
                          onDrop={(acceptedFiles, fileRejections) =>
                            onDrop(
                              acceptedFiles,
                              fileRejections,
                              15000000,
                              () => handleVideoSelected(acceptedFiles)
                            )
                          }
                          maxSize={15000000}
                          accept={['.3gp', '.mp4']}
                          suggestion={
                            campanha?.name
                              ? `Arquivo de no máximo 15M<br/>Arquivo selecionado: <strong>${campanha.name}</strong>`
                              : 'Arquivo de no máximo 15M'
                          }
                        />
                      </div>
                    </FormGroup>
                  </Col>
                )}
                {type === 'audio-arquivo' && (
                  <Col xl={4} md={4}>
                    <FormGroup>
                      <Label for="exampleEmail">Arquivo</Label>
                      <div className="file-uploader">
                        <Input
                          type="file"
                          isDisabled={block}
                          label="Upload"
                          onChange={handleVideoSelected}
                          accept=".ogg, .mp3"
                        />
                      </div>
                    </FormGroup>
                  </Col>
                )}
                {type === 'link' && (
                  <>
                    <Col xl={4} md={4}>
                      <InputComponent
                        label="Link*"
                        onChange={(value) => setLinkUrl(value.target.value)}
                        value={linkUrl}
                      />
                    </Col>
                  </>
                )}

                {!block && (
                  <>
                    {(type === 'botoes' || type === 'imagem-botoes') && (
                      <Col xl={4} md={4}>
                        <InputComponent
                          label="Titulo dos Botões"
                          onChange={(value) =>
                            setTituloLink(value.target.value)
                          }
                          value={tituloLink}
                        />
                      </Col>
                    )}
                    {(type === 'botoes' || type === 'imagem-botoes') && (
                      <>
                        <Col xl={4} md={4}>
                          <InputComponent
                            label="Botão 1*"
                            onChange={(value) => setBtn1(value.target.value)}
                            value={btn1}
                          />
                        </Col>
                        <Col xl={4} md={4}>
                          <InputComponent
                            label="Botão 2*"
                            onChange={(value) => setBtn2(value.target.value)}
                            value={btn2}
                          />
                        </Col>
                        <Col xl={4} md={4}>
                          <InputComponent
                            label="Botão 3*"
                            onChange={(value) => setBtn3(value.target.value)}
                            value={btn3}
                          />
                        </Col>
                      </>
                    )}
                  </>
                )}

                {!block && type === 'arquivo' && (
                  <Col xl={4} md={4}>
                    <InputComponent
                      label="Nome do Arquivo"
                      onChange={(value) => setNomeDoArquivo(value.target.value)}
                      value={nomeDoArquivo}
                    />
                  </Col>
                )}

                {/* {!block && (
                  <Col xl={4} md={4} className={styles.checkSair}>
                    <Label for="exampleEmail">Possibilitar Sair</Label>
                    <Switch
                      onChange={() => {
                        setCheckSair(!checkSair)
                      }}
                      checked={checkSair}
                    />
                  </Col>
                )} */}
                  </Row>
                </>
                      )}
                    </>
                  )}

                  {activeStep === 1 && (
                    <SectionCard
                      title="Contatos"
                      subtitle="Envie a planilha com seus contatos ou use uma lista já cadastrada."
                    >
                      <PlanilhaUploadCard
                        fileName={file?.name}
                        contactCount={tableConfig.total}
                        fileError={planilhaFileError}
                        disabled={loading}
                        onClear={clearPlanilha}
                        onDropAccepted={handlePlanilhaDrop}
                      />
                      <SpreadsheetInfoBanner />
                      <p className="text-muted small mt-2 mb-0">
                        Telefone em qualquer formato.{' '}
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0 align-baseline"
                          style={{ color: '#185FA5' }}
                          onClick={downloadModeloPlanilha}
                        >
                          Baixar modelo de planilha
                        </button>
                      </p>
                      {userPlan !== 'BASIC' && user && (
                        <div className="mt-3 pt-3 border-top">
                          <span className="small text-muted d-block mb-2">
                            Ou use lista já cadastrada:
                          </span>
                          <FormGroup className="mb-2">
                            <Label for="grupos-disparo" className="small">
                              Grupos de disparo
                            </Label>
                            <Select
                              inputId="grupos-disparo"
                              value={
                                grupoList.find((a) => a.value === grupo)
                                  ? grupoList.find((a) => a.value === grupo)
                                  : null
                              }
                              onChange={(value) => handlerGrupo(value)}
                              options={grupoList}
                              classNamePrefix="select2-selection"
                              placeholder="Selecione..."
                            />
                          </FormGroup>
                          <FormGroup className="mb-0">
                            <Label for="segmentacoes" className="small">
                              Segmentações
                            </Label>
                            <Select
                              inputId="segmentacoes"
                              value={
                                segmentacoesList.find(
                                  (a) => a.value === segmentation
                                )
                                  ? segmentacoesList.find(
                                      (a) => a.value === segmentation
                                    )
                                  : null
                              }
                              onChange={(value) => handlerSegmentation(value)}
                              options={segmentacoesList}
                              classNamePrefix="select2-selection"
                              placeholder="Selecione..."
                            />
                          </FormGroup>
                        </div>
                      )}
                      {tableConfig.total === 0 ? (
                        <div className="mt-3">
                          <ContactsEmptyState />
                        </div>
                      ) : null}
                    </SectionCard>
                  )}

                  {activeStep === 2 && (
                    <SectionCard
                      title="Mensagem"
                      subtitle="Escreva o texto e use as variáveis para personalizar por contato."
                    >
                      {!block && (
                        <FormGroup>
                          <FormLabelWithTooltip
                            htmlFor="message-text-area"
                            required
                            tooltip="Corpo da mensagem enviada no WhatsApp."
                          >
                            Texto da mensagem
                          </FormLabelWithTooltip>
                          <TextArea
                            title={false}
                            hideLabel
                            value={message}
                            setValue={setMessage}
                            onAddVariable={handleAddVariable}
                            messagevariables={messageVariables}
                            variableLayout="chips"
                            placeholder="Olá {nome}, temos uma novidade para você!"
                            maxLength={4096}
                            showCharCounter
                          />
                        </FormGroup>
                      )}
                    </SectionCard>
                  )}

                  {activeStep === 3 && (
                    <SectionCard
                      title="Revisar"
                      subtitle="Confira os dados antes de confirmar o disparo."
                    >
                      <ReviewPanel
                        campaignName={descricao}
                        contactCount={tableConfig.total}
                        message={message}
                        scheduleLabel={formatScheduleLabel(
                          momento,
                          horaEnvioDatePicker
                        )}
                        sampleContacts={tabela}
                        extraVariables={messageVariables}
                      />
                      <div className="d-flex flex-wrap justify-content-between gap-2 mt-4 enviar-planilha-review-actions">
                        <Button
                          type="button"
                          variant="outline-secondary"
                          onClick={() => setActiveStep(2)}
                        >
                          Voltar
                        </Button>
                        {statusInstancia ? (
                          <Button
                            type="button"
                            className="enviar-planilha-btn-primary"
                            disabled={loading || !canReview}
                            onClick={submitDisparo}
                          >
                            {loading ? 'Enviando…' : 'Confirmar envio'}
                          </Button>
                        ) : (
                          <span className="text-muted small align-self-center">
                            Selecione &quot;Quem está enviando a mensagem?&quot; na etapa Campanha.
                          </span>
                        )}
                      </div>
                    </SectionCard>
                  )}
                </div>

                {activeStep < 3 && (
                  <Row className="mt-4 pt-3 enviar-planilha-actions">
                    <Col
                      xs={12}
                      className="d-flex flex-wrap justify-content-between align-items-center gap-2 enviar-planilha-step-footer"
                    >
                      <div>
                        {activeStep > 0 ? (
                          <Button
                            type="button"
                            variant="outline-secondary"
                            onClick={() => setActiveStep((s) => Math.max(0, s - 1))}
                          >
                            Voltar
                          </Button>
                        ) : null}
                      </div>
                      <div className="d-flex flex-wrap enviar-planilha-footer-actions ms-auto">
                        <Button
                          type="button"
                          variant="outline-secondary"
                          onClick={saveDraft}
                        >
                          Salvar rascunho
                        </Button>
                        {activeStep < 2 ? (
                          <Button
                            type="button"
                            className="enviar-planilha-btn-primary"
                            disabled={!stepComplete(activeStep)}
                            onClick={() =>
                              setActiveStep((s) => Math.min(2, s + 1))
                            }
                          >
                            Próximo passo
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="enviar-planilha-btn-primary"
                            disabled={!canReview}
                            onClick={() => setActiveStep(3)}
                          >
                            Revisar e enviar
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EnviarPlanilha
